import React from "react";
import { Fade } from "@material-ui/core";

const logoUrl = `${process.env.PUBLIC_URL}/logo/Logo_LC_BANK.png`;

const LuxLogo = () => {
  return (
    <Fade in>
      <div style={{ textAlign: "center", marginTop: 48, marginBottom: 32 }}>
        <img src={logoUrl} alt="logo" width="200" height="200" />
      </div>
    </Fade>
  );
};

export default React.memo(LuxLogo);
